module.exports = __webpack_public_path__ + "img/sol_cap3.714413cd.png";